import { Component } from "@angular/core";

@Component({
  selector: "app-flex",
  templateUrl: "./flex.component.html",
  styleUrls: ["./flex.component.scss"],
})
export class FlexComponent {
  toggle = false;
  documents = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ];

  expand() {
    this.toggle = true;
  }

  collapse() {
    this.toggle = false;
  }

  get chartClass() {
    return this.toggle ? "hidden" : "";
  }

  get chartConClass() {
    return this.toggle ? "chart-con expanded" : "chart-con";
  }

  get expandClass() {
    return this.toggle ? "expand-con" : "hidden";
  }

  get thumbClass() {
    return this.toggle ? "hidden" : "thumbnail-con";
  }

  trackByIndex(index, item) {
    return index;
  }
}
